import { select_default_value_all } from "./Constants";

export const setFilterOptions = (responseArray, key, sortType = 'none') => {
    let regions = new Set()
    let filterRegions = []
    responseArray?.forEach((item) => {
      regions.add(item[key])
    })
    regions.forEach((item) => {
      filterRegions.push({ label :item , value :item})
    })
    
    if (sortType === 'alphabetical') {
      filterRegions.sort((a, b) => a.label.localeCompare(b.label))
    } else if (sortType === 'reverse') {
      filterRegions.sort((a, b) => b.label.localeCompare(a.label))
    } else if (sortType === 'date') {
      filterRegions.sort((a, b) => {
        const dateA = new Date(a.label)
        const dateB = new Date(b.label)
        if (!isNaN(dateA) && !isNaN(dateB)) {
          return dateB - dateA
        }
        return b.label.localeCompare(a.label)
      })
    }
    
    return filterRegions
  }

  export const setFilterOptionsWithAll = (responseArray, key, sortType = 'none') => {
    let filterRegions = setFilterOptions(responseArray, key, sortType)
    filterRegions.push(select_default_value_all)
    return filterRegions
  }